import request from '../../http.js';

// 判断是否登录
export function islogin() {
    return request({
        url: '/api/index/userInfo',
        method: 'get',
    })
};

//登录
export function login(email, pwd) {
    const data = {
        email,
        pwd,
    }
    return request({
        url: '/api/index/login',
        method: 'post',
        data: data,
    })
};

// 注册
/*name:用户名
  email: 邮箱
  email_code: 验证码
  pwd: 密码
  repwd:确认密码*/
export function register(datas) {
    return request({
        url: '/api/index/ajaxReg',
        method: 'post',
        data: datas,
    })
}
// 注册验证码
export function RCode(email) {
    var data = {
        email,
    };
    return request({
        url: '/api/index/get_code',
        method: 'post',
        data: data,
    })
}

// 忘记密码
/*email:邮箱
  email_code: 验证码
  pwd: 密码
  repwd: 确认密码*/
export function fpwd(datas) {
    return request({
        url: '/api/index/resetpwd',
        method: 'post',
        data: datas,
    })
}
// 忘记密码验证码
export function FCode(email) {
    var data = {
        email,
    };
    return request({
        url: '/api/index/getreset_code',
        method: 'post',
        data: data,
    })
}


// 退出登录
export function logout() {
    return request({
        url: '/api/index/logout',
        method: 'get',
    })
}


// WEBPACK FOOTER //
// ./src/https/api/user/user.js